import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {

}

const getters = {

}

const actions = {
    getMainProjects ({ commit }, params) {
        return Service.MainProject.getMainProjects(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getMainProjectById ({ commit }, params) {
        return Service.MainProject.getMainProjectById(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getMasterMainProject ({ commit }, params) {
        return Service.MainProject.getMasterMainProject().then(res => {
            return checkAndReturn(params, res)
        })
    },

    storeMainProject ({ commit }, data) {
        return Service.MainProject.storeMainProject(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    getMainProjectsByUSP ({ commit }, data) {
        return Service.MainProject.getMainProjectsByUSP(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
